import ServiceBase from "../../../servicebase";
import { PaginatedResponse, Response } from "../../../../model";

export class ControllerEntityService<TEditOut,TEditIn,TListOut,TComboItem,TFindExtraFilters,TComboExtraFilters> extends ServiceBase {
  _controller: string = '';
  _entity: string = '';

  constructor(api: string, controller: string, entity: string) {
    super(api);
    this._controller = controller;
    this._entity = entity;
  }
  
  getEdit = (data: { id?: number }) => 
    this.GetFetch<Response<TEditOut>>(`${this._controller}/${this._entity}/edit`, data);
  
  combo = (data: TComboExtraFilters & { activos?: boolean, includeTodos?: boolean, includeNinguno?: boolean, includeId?: number }) => 
    this.GetFetch<Response<TComboItem[]>>(`${this._controller}/${this._entity}/combo`, data);

  find = (data: TFindExtraFilters & { pageIndex?: number, pageSize?: number, sort?: string, activo?: boolean, esglobal?: boolean }) => 
    this.GetFetch<PaginatedResponse<TListOut>>(`${this._controller}/${this._entity}/find`, data);

  upsert = (data:TEditIn) => 
    this.PostFetch<Response<number>>(`${this._controller}/${this._entity}`, data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<Response<void>> => 
    this.DeleteFetch<Response<void>>(`${this._controller}/${this._entity}`, data);

}